import React, { createContext, useContext, useEffect, useState } from 'react';

// Create the context
const AuthContext = createContext();

// Provider component
export const AuthProvider = ({ children }) => {
  // Load from localStorage initially
  const [isLogin, setIsLogin] = useState(
    () => localStorage.getItem('islogin') === 'true'
  );

  const login = () => {
    localStorage.setItem('islogin', 'true');
    setIsLogin(true);
  };

  const logout = () => {
    setIsLogin(false);
    localStorage.removeItem('islogin');
    localStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider value={{ isLogin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook to use the context easily
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside AuthProvider');
  }
  return context;
};
